// extracted by mini-css-extract-plugin
export default {"container":"styles_container__D7aBW","logoWrapper":"styles_logoWrapper__xe8LR","logo":"styles_logo__13Es-"};